import { Link } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";

interface Props {
  title?: string;
  description?: string;
  backTo?: string;
  backLabel?: string;
  icon?: string;
}

export default function EmptyState({
  title = "暂无推荐内容",
  description = "内容还在整理中，先去其他栏目逛逛吧。",
  backTo = "/",
  backLabel = "返回首页",
  icon = "ri-inbox-line",
}: Props) {
  return (
    <SiteLayout>
      <div className="mx-auto flex w-full max-w-content flex-col items-center justify-center px-4 py-24 text-center md:px-6 md:py-32">
        <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-50 text-primary-600">
          <i className={`${icon} text-3xl leading-none`} />
        </span>
        <h1 className="mt-6 font-heading text-xl font-bold text-foreground-950 md:text-2xl">{title}</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-600">{description}</p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to={backTo}
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-home-4-line text-base leading-none" />
            </span>
            {backLabel}
          </Link>
          <Link
            to="/category"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            浏览影视分类
          </Link>
        </div>
      </div>
    </SiteLayout>
  );
}